import "./currency-picker.scss";

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAnalyticsAction, IApplicationState } from '../../store';
import useVenueBackedCurrencies from '../../hooks/useVenueBackedCurrencies';

import { actionCreators as giftVoucherActions } from '../../store/GiftVoucher';

import { Select } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { GoogleTagManagerEvents } from "../../helpers/googleTagManager";
const { Option } = Select;

//Allows selecting the currency from a list of available currencies you wish to buy a global gift voucher with
// NOTE currently buying a gift voucher in AUD means both you are paying in AUD, and you are loading AUD onto the card

const CurrencyPicker = (): React.ReactElement => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const selectedCurrency = useSelector((state: IApplicationState) => state.giftVoucher.selectedVoucherCurrency);

    const { currencies: availableCurrencies } = useVenueBackedCurrencies();

    const placeholder = t('globalGiftVouchers.currencyPicker.PleasePick');

    const items = useMemo(() => {

        //return every available currency into a list item we can display and click
        return availableCurrencies.map((item) => {

            let currencyDescription = t(`globalGiftVouchers.currencyPicker.currencyDescription.${item.code}`);
            const label = `${item.symbol} - ${item.code} - ${currencyDescription}`;
            return (
                <Option className="zl-currency-option" value={item.id} key={item.id} >
                    {label}
                </Option>
            )
        });

    }, [t, availableCurrencies]);


    const onChange = (value: number) => {
        const clickedCurrency = availableCurrencies.find(c => c.id === value);
        if (clickedCurrency) {

            dispatch(giftVoucherActions.selectVoucherCurrency(clickedCurrency));

            // GTM
            dispatch({
                type: 'CURRENCY_SELECTED',
                googleTagManagerEvent: GoogleTagManagerEvents.GlobalGifts_CurrencySelected(clickedCurrency),
            } as IAnalyticsAction);
        }
    };


    return (
        <Select
            data-testid="currency-dropdown"
            showSearch
            onSelect={onChange}
            value={selectedCurrency?.id}
            className="zl-currency-dropdown"
            popupClassName="zl-currency-dropdown-menu"
            size="large"
            suffixIcon={<CaretDownFilled />}
            placeholder={placeholder}

            optionFilterProp="children"
            filterOption={(input, option) => {
                const text = String(option?.children ?? "");
                return text.toLowerCase().includes(input.toLowerCase());
            }}
        >
            {items}
        </Select>
    );
};

export default CurrencyPicker;
